export const hbtTheme = {
    token: {
        colorPrimary: '#B91C1C',
        colorSuccess: '#059669',
        colorWarning: '#D97706',
        colorError: '#DC2626',
        colorInfo: '#0F766E',
        borderRadius: 8,
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Noto Sans SC", sans-serif',
    },
    components: {
        Layout: {
            headerBg: '#7F1D1D',
            headerColor: '#FEF3C7',
            siderBg: '#1F1B1A',
            bodyBg: '#FAFAF7',
        },
        Menu: {
            darkItemBg: '#1F1B1A',
            darkSubMenuItemBg: '#100D0C',
            darkItemSelectedBg: '#7F1D1D',
            darkItemHoverBg: '#3A2020',
        },
        Table: { headerBg: '#F7F1EE', headerColor: '#4B2A2A' },
        Button: { fontWeight: 500 },
    },
};
